<script>
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import * as m from '@app/paraglide/messages.js';
    import flexbox from "@cclib/dict/flexbox.js";
    
    /** @type {{eventIndex: any, height?: number, rounded?: boolean}} */
    let { event, eventIndex, height = 160, rounded = true } = $props();
    
    // Correct $derived syntax - no extra parentheses needed
    let currentEvent = $derived(event || eventGroupState[projectState.selected]?.events[eventIndex]);
    let eventText = $derived(currentEvent ? highlightExcessCharacters(currentEvent.text) : "");
    
    function highlightExcessCharacters(htmlString) {
        if (!htmlString || !eventGroupState[projectState.selected]) return "";
        
        const doc = new DOMParser().parseFromString(htmlString, "text/html");
        const limit = eventGroupState[projectState.selected]?.maxChars;
    
        doc.querySelectorAll("p").forEach((p) => {
            const text = p.textContent;
            if (text.length > limit) {
                const before = text.slice(0, limit);
                const after = text.slice(limit);
    
                // Rebuild the line using text nodes so literal < and > are never parsed as tags.
                p.replaceChildren();
                p.append(doc.createTextNode(before));
    
                const excessSpan = doc.createElement("span");
                excessSpan.className = "bg-danger";
                excessSpan.textContent = after;
                p.append(excessSpan);
            }
        });
        
        return doc.body.innerHTML;
    }
    </script>
    
    <div
        role="region"
        aria-label={m.event_preview_aria_label()}
        class="text-white bg-secondary bg-opacity-50 p-2 EditorPreviewText {rounded ? 'rounded' : ''} text-{flexbox
            .alignmentMap[currentEvent?.alignment]}"
        style="height:{height}px; font-family: '{eventGroupState[projectState.selected]?.fontFamily || 'plexMono'}' !important; font-size: {eventGroupState[projectState.selected]?.fontSize || 18}px; line-height: 100%; direction: {eventGroupState[
            projectState?.selected
        ]?.rtl
            ? 'rtl'
            : 'ltr'};">
        {@html eventText}
    </div>
    
    <style lang="css">
    .EditorPreviewText {
        overflow-y: auto;
        overflow-x: hidden;
    }
    </style>